import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import AuthForm from "../components/AuthForm";

export default function Register({ setIsLoggedIn }) {
  const navigate = useNavigate();
  const [verificationState, setVerificationState] = useState(null);
  const [isResending, setIsResending] = useState(false);

  const handleRegister = async (form) => {
    try {
      const res = await axios.post(`${process.env.REACT_APP_API}/register`, form);

      if (res.data.token) {
        localStorage.setItem("token", res.data.token);
        setIsLoggedIn?.(true);
        // Free mode: backend reports no billing setup needed
        if (res.data.user && res.data.user.needs_billing_setup) {
          navigate("/refer/billing");
        } else {
          navigate("/refer/dashboard");
        }
        return;
      }

      if (res.data.requires_email_verification) {
        setVerificationState({
          email: form.email,
          message: res.data.msg,
        });
        return;
      }

      navigate("/refer/login");
    } catch (err) {
      console.error(err);
      const errorMsg = err.response?.data?.msg || "Registration failed";
      alert(errorMsg);
    }
  };

  const resendVerification = async () => {
    if (!verificationState?.email) return;

    try {
      setIsResending(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API}/resend-verification`,
        { email: verificationState.email }
      );
      setVerificationState((current) => ({
        ...current,
        message: response.data.msg,
      }));
    } catch (error) {
      console.error("Failed to resend verification email:", error);
      alert(error.response?.data?.error || "Failed to resend verification email.");
    } finally {
      setIsResending(false);
    }
  };

  if (verificationState) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen px-4 bg-backgroundLight">
        <div className="w-full max-w-lg bg-white p-8 rounded shadow-md text-center">
          <div className="text-5xl mb-4">✉️</div>
          <h1 className="text-2xl font-semibold mb-3">Verify Your Email</h1>
          <p className="text-gray-600 mb-2">{verificationState.message}</p>
          <p className="text-gray-500 mb-6">
            We sent the verification link to <strong>{verificationState.email}</strong>.
          </p>

          <div className="flex flex-col gap-3">
            <button
              onClick={resendVerification}
              disabled={isResending}
              className="w-full bg-primary text-white px-4 py-2 rounded font-semibold shadow hover:opacity-90 transition disabled:opacity-50"
              style={{ backgroundColor: "#30853A" }}
            >
              {isResending ? "Sending..." : "Resend Verification Email"}
            </button>

            <Link
              to="/refer/login"
              className="w-full border border-gray-300 px-4 py-2 rounded font-medium text-gray-700 hover:bg-gray-50"
            >
              Back to Login
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <AuthForm onSubmit={handleRegister} label="Register" />
    </div>
  );
}
